<highcharts-chart
    class="vc-area-spline-chart no-title"
    [style.height]="height"
    [options]="options"
    (chartInstance)="onChartInstance($event)">
</highcharts-chart>
